// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10F9t","label":"styles_label__1nbqJ"};